import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

export const useStations = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  const createStations = async (instance, stationGroup, workspace, env) => {
    setError(null);
    setIsPending(true);

    try {
      //signup user
      const res = await httpsCallable(
        functions,
        "createDeviceStation"
      )({
        instance: instance,
        stationGroup: stationGroup,
        workspace: workspace,
        env: env,
      });
      if (!res) {
        throw new Error("could not complete stations");
      }

      console.log(res);
      setIsPending(false);
      setError(null);
      return res;
    } catch (err) {
      console.log(err.message);
      setError(err.message);
      setIsPending(false);
    }
  };

  return { error, isPending, createStations };
};
